<template>
  <div class="Proposal">
    <ProposalBuilder v-if="passShowComp === 'Builder'" :updateMode="updateMode" @return="showReviewHandler" :context="passContext" />
    <ProposalReview v-else-if="passShowComp === 'Review'" :context="passContext" @return="showCompHandler" :duration="duration" />
    <ProposalList v-else-if="passShowComp === 'List'" />    
  </div>
</template>

<script>
  import ProposalList from '@/components/proposalcomps/ProposalList.vue';
  import ProposalBuilder from '@/components/proposalcomps/ProposalBuilder.vue';
  import ProposalReview from '@/components/proposalcomps/ProposalReview.vue';
  import {getTPAID} from '@/store/global_helpers/sessionReturn.js';
  import {mapActions, mapGetters} from 'vuex';
  export default {
    data: () => ({
      passContext: null,
      passShowComp: 'List',
      duration: 5,
    }),

    props: {
      showComp: [String],
      updateMode: [Boolean],
      context: [Object, String],
    },
    
    created() {
      let entity =  {
          type: 'tpa',
          id: getTPAID()
        }      
      this.getUserList(entity)      
      this.getLoiList();
      this.getStatusList();
      this.getUserObject();
    },
    
    mounted () {
      if (this.showComp === 'List'){
        this.loadProposalList();
      }
      this.passContext = this.context
      this.passShowComp = this.showComp;
    },
    
    computed: {
      ...mapGetters({
        auth: 'authContext',
        client: 'readClient'
      }),
      mobile () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return true;
              case 'sm': return true;
              case 'md': return false;
              case 'lg': return false;
              case 'xl': return false;
            }
            return null
        },
    },
    
    methods: {
        ...mapActions([
          'getProposalList', 
          'loadingStatus', 
          'fetchProposalOptions', 
          'fetchProposalSettings', 
          'fetchPricingDefaults',
          'getProposal',
          'getUserList',
          'loadTPAPricing',
          'getUserObject',
          'getLoiList',
          'getStatusList',
          ]),
        
        proposalListStatus() {
          this.loadingStatus();
        },

        showCompHandler(val){
          console.log('showCompHandler called');
          if (val === "List") this.loadProposalList()
          this.passShowComp = val;
        },

        showReviewHandler(val){
          this.passShowComp = val.showComp
          this.duration = val.duration
        },

        loadProposalList () {
          let entity = {
            id: this.auth.tpaID,
            type: 'tpa'
          };
          console.log(entity)
          this.getProposalList(entity);
        },
    },

    components: { 
      ProposalList,
      ProposalBuilder,
      ProposalReview
      },
  };
</script>
